module.exports = __webpack_public_path__ + "static/media/Sleekflow_logo_svg.0ce94a6d.svg";